"use client";

import { useRef, useState } from "react";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";

interface ReadMoreTextProps {
  text: string;
  html?: string;
  collapsedClassName?: string;
  contentClassName?: string;
}

export default function ReadMoreText({
  text,
  html,
  collapsedClassName = "max-h-44 overflow-hidden",
  contentClassName = "whitespace-pre-line text-sm leading-8 text-[#4b5563]",
}: ReadMoreTextProps) {
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const canCollapse = text.length > 280 || text.split("\n").length > 4;

  const toggleExpanded = () => {
    if (expanded) {
      setExpanded(false);
      window.requestAnimationFrame(() => {
        containerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
      return;
    }

    setExpanded(true);
  };

  return (
    <div ref={containerRef} className="scroll-mt-32">
      <div className="relative">
        {html ? (
          <div
            className={`${contentClassName} ${
              !expanded && canCollapse ? collapsedClassName : ""
            }`}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <p
            className={`${contentClassName} ${
          !expanded && canCollapse ? collapsedClassName : ""
        }`}
      >
        {text}
      </p>
        )}
        {!expanded && canCollapse ? (
          <span className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-white/0" />
        ) : null}
      </div>
      {canCollapse ? (
        <button
          type="button"
          onClick={toggleExpanded}
          className="mt-4 inline-flex min-h-10 items-center gap-2 rounded-xl border border-primary/20 bg-primary/5 px-4 py-2 text-sm font-extrabold text-primary transition hover:border-primary/40 hover:bg-primary/10"
        >
          {expanded ? "نمایش کمتر" : "مشاهده بیشتر"}
          <PhosphorIcon name={expanded ? "CaretUp" : "CaretDown"} size={14} />
        </button>
      ) : null}
    </div>
  );
}
